import { AxiosError } from 'axios';
import { get, post } from '@/utils';
import i18n from '@/i18n';
import { IVersion } from './types';

type IVersionResponse = {
	items?: IVersion[];
	pageNumber?: number;
	totalPages?: number;
	totalCount?: number;
	orderBy?: string | null;
	ascending?: boolean;
	hasPreviousPage?: boolean;
	hasNextPage?: boolean;
};

async function fetchVersions(
	page: number,
	items: number,
	onResponse?: (page: number, items: number) => void
): Promise<IVersion[]> {
	try {
		const res = await get(`api/mobile-releases?PageNumber=${page + 1}&PageSize=${items}`);
		onResponse && onResponse(res.data?.totalPages, res?.data?.totalCount);
		const data = res.data as IVersionResponse;
		return data?.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || i18n.t('versions.errorLoad'));
	}
}

async function fetchSingleVersion(id: number | string): Promise<IVersion> {
	try {
		const res = await get(`api/mobile-releases/${id}`);
		const data = res.data as IVersion;
		return data || ({} as IVersion);
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || i18n.t('versions.errorLoad'));
	}
}
async function fetchVersionQuery(
	query: string,
	page: number,
	items: number,
	onResponse?: (page: number, items: number) => void
): Promise<IVersion[]> {
	try {
		const res = await get(
			`api/mobile-releases${query}&PageNumber=${page + 1}&PageSize=${items}`
		);
		onResponse && onResponse(res.data?.totalPages, res?.data?.totalCount);
		const data = res.data as IVersionResponse;
		return data?.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || i18n.t('versions.errorLoad'));
	}
}

async function setRequiredVersion(id: number | string): Promise<number | string> {
	try {
		const res = await post(`api/mobile-releases/${id}/required`);
		return res?.status === 200 || res?.status === 201 ? 200 : 400;
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || i18n.t('versions.errorSetMinimum'));
	}
}

export { fetchVersions, fetchSingleVersion, fetchVersionQuery, setRequiredVersion };
